<template>
    <v-dialog v-model="show" persistent width="500px">
        <v-wait for="loading service data">
            <template slot="waiting">
                <v-card>
                    <v-toolbar dark color="primary"></v-toolbar>
                    <vcl-list height="200"></vcl-list>
                </v-card>
            </template>
            <v-card v-if="service">
                <v-toolbar dark color="primary" v-if="service">
                    <v-toolbar-title>
                        Service for
                        <router-link
                            class="accent--text text--lighten-1"
                            :to="{ name: 'unit', params: { unitId: service.unitId } }"
                        >{{ service.unitNumber }}
                        </router-link>
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn @click="close" icon text>
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-toolbar>

                <v-layout column class="mx-4">
                    <v-list>
                        <v-list-item>
                            <v-list-item-content>
                                <v-list-item-title>What's been completed?</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                        <div v-if="service.hrsTasks.length > 0"
                             v-for="(task, index) in service.hrsTasks"
                        >
                          <v-list-item
                            :key="index"
                            @click="!disableTasks && toggleTask(task, $event, model.completedHrsTasks)"
                          >
                            <v-list-item-action>
                                <v-checkbox
                                    v-model="model.completedHrsTasks"
                                    :value="task.id"
                                    v-validate="completedServiceBeingUpdatedByFleetManager ? '' : 'at-least-one'"
                                    name="completed tasks"
                                    :disabled="disableTasks"
                                ></v-checkbox>
                            </v-list-item-action>
                            <v-list-item-content>
                                <v-list-item-title>{{ task.shortName }}</v-list-item-title>
                            </v-list-item-content>
                            <v-list-item-action>
                                <v-row align="center" >
                                  <div v-if="task.allowAttachments">
                                    <document-input v-if="hasPendingDocuments(task)" 
                                      @change="selectFiles($event, task)" 
                                      :name="'required-docs'"
                                      v-validate="'required-documents:' + task.id+','+task.documentationRequired"
                                    />
                                  </div>
                                  <v-chip
                                      v-if="task.originalDueAtTolerance || task.originalDueAtTolerance === 0"
                                      class="mr-2"
                                      label
                                      small
                                      :color="task.originalDueAtTolerance > 0 ? 'red' : null"
                                      :dark="task.originalDueAtTolerance > 0 ? true : null"
                                  >{{ task.originalDueAtTolerance > 0 ? `+${task.originalDueAtTolerance}` : task.originalDueAtTolerance }} {{ task.intervalTypeUnits }}
                                  </v-chip>
                                </v-row>
                            </v-list-item-action>
                          </v-list-item>
                          <div v-if="task.allowAttachments">
                              <v-list-item v-if="!hasPendingDocuments(task)">
                                <v-col>
                                  <v-chip style="height: auto; margin-bottom: 5px" class="mr-2" label small download v-for="(document, index) in task.documents" :key="index" :href="document.documentUrl" target="_blank">
                                    {{ document.blobName }}
                                  </v-chip>
                                </v-col>
                                <v-btn v-if="userIsFleetManager" @click="clearAttachments(task)" small icon text>
                                    <v-icon>close</v-icon>
                                </v-btn>
                              </v-list-item>                    
                          </div>  
                        </div>
                    </v-list>
                    <span
                        v-if="errors.first('completed tasks') "
                        class="ml-4 error--text"
                    >select at least one task</span>
                    <decimal
                        v-if="service.hrsTasks.length > 0"
                        v-model="model.completedAtHrs"
                        placeholder="when was the work completed?"
                        v-validate="model.completedHrsTasks.length > 0 ? 'required|completed-in-range-hrs:' + model.completedDate : 'completed-in-range-hrs:' + model.completedDate"
                        name="completed at hours"
                        :error-messages="errors.first('completed at hours')"
                        :precision="1"
                        required
                    >
                        <template v-slot:prepend>Completed&nbsp;at</template>
                        <template v-slot:append>hrs</template>
                    </decimal>
                </v-layout>

                <v-layout column class="mx-4">
                    <v-list v-if="service.kmsTasks.length > 0">
                        <div v-for="(task, index) in service.kmsTasks">
                            <v-list-item
                                :key="index"
                                @click="!disableTasks && toggleTask(task, $event, model.completedKmsTasks)"
                            >
                                <v-list-item-action>
                                    <v-checkbox
                                        v-model="model.completedKmsTasks"
                                        :value="task.id"
                                        v-validate="completedServiceBeingUpdatedByFleetManager ? '' : 'at-least-one'"
                                        name="completed tasks"
                                        :disabled="disableTasks"
                                    ></v-checkbox>
                                </v-list-item-action>

                                <v-list-item-content>
                                    <v-list-item-title>{{ task.shortName }}</v-list-item-title>
                                </v-list-item-content>

                                <v-list-item-action>
                                    <v-row>
                                      <div v-if="task.allowAttachments">
                                        <document-input v-if="hasPendingDocuments(task)" 
                                          @change="selectFiles($event, task)" 
                                          :name="'required-docs'"
                                          v-validate="'required-documents:' + task.id+','+task.documentationRequired"
                                        />
                                      </div>
                                      <v-chip
                                          v-if="task.originalDueAtTolerance || task.originalDueAtTolerance === 0"
                                          class="mr-2"
                                          label
                                          small
                                          :color="task.originalDueAtTolerance > 0 ? 'red' : null"
                                          :dark="task.originalDueAtTolerance > 0 ? true : null"
                                      >{{ task.originalDueAtTolerance > 0 ? `+${task.originalDueAtTolerance}` : task.originalDueAtTolerance }} {{ task.intervalTypeUnits }}
                                      </v-chip>
                                    </v-row>
                                </v-list-item-action>
                            </v-list-item>
                            <div v-if="task.allowAttachments">
                                <v-list-item v-if="!hasPendingDocuments(task)">
                                    <v-btn small outlined download v-for="(document, index) in task.documents" :key="index" :href="document.documentUrl" target="_blank">
                                      {{ document.blobName }}
                                    </v-btn>
                                    <v-btn v-if="userIsFleetManager" @click="clearAttachments(task)" small icon text>
                                        <v-icon>close</v-icon>
                                    </v-btn>
                                </v-list-item>                    
                            </div>  
                        </div>
                    </v-list>
                    <span
                        v-if="errors.first('completed tasks') && service.kmsTasks.length > 0"
                        class="ml-4 error--text"
                    >select at least one task</span>
                    <decimal
                        v-if="service.kmsTasks.length > 0"
                        v-model="model.completedAtKms"
                        placeholder="when was the work completed?"
                        v-validate="model.completedKmsTasks.length > 0 ? 'required|completed-in-range-kms:' + model.completedDate : 'completed-in-range-kms:' + model.completedDate"
                        name="completed at kms"
                        :error-messages="errors.first('completed at kms')"
                        :precision="1"
                        required
                    >
                        <template v-slot:prepend>Completed&nbsp;at</template>
                        <template v-slot:append>kms</template>
                    </decimal>
                </v-layout>

                <v-layout column class="mx-4">
                    <v-list v-if="service.otherTasks.length > 0">
                        <div v-for="(task, index) in service.otherTasks">
                            <v-list-item
                                :key="index"
                                @click="!disableTasks && toggleTask(task, $event, model.completedOtherTasks)"
                            >
                                <v-list-item-action>
                                    <v-checkbox
                                        v-model="model.completedOtherTasks"
                                        :value="task.id"
                                        v-validate="completedServiceBeingUpdatedByFleetManager ? '' : 'at-least-one'"
                                        name="completed tasks"
                                        :disabled="disableTasks"
                                    ></v-checkbox>
                                </v-list-item-action>

                                <v-list-item-content>
                                    <v-list-item-title>{{ task.shortName }}</v-list-item-title>
                                </v-list-item-content>

                                <v-list-item-action>
                                    <v-row>
                                      <div v-if="task.allowAttachments">
                                        <document-input v-if="hasPendingDocuments(task)" 
                                          @change="selectFiles($event, task)" 
                                          :name="'required-docs'"
                                          v-validate="'required-documents:' + task.id+','+task.documentationRequired"
                                        />
                                      </div>  
                                      <v-chip
                                          v-if="task.originalDueAtTolerance || task.originalDueAtTolerance === 0"
                                          class="mr-2"
                                          label
                                          small
                                          :color="task.originalDueAtTolerance > 0 ? 'red' : null"
                                          :dark="task.originalDueAtTolerance > 0 ? true : null"
                                      >{{ task.originalDueAtTolerance > 0 ? `+${task.originalDueAtTolerance}` : task.originalDueAtTolerance }} {{ task.intervalTypeUnits }}
                                      </v-chip>
                                    </v-row>
                                </v-list-item-action>
                            </v-list-item>
                            <div v-if="task.allowAttachments">
                                <v-list-item v-if="!hasPendingDocuments(task)">
                                    <v-btn small outlined download v-for="(document, index) in task.documents" :key="index" :href="document.documentUrl" target="_blank">
                                      {{ document.blobName }}
                                    </v-btn>
                                    <v-btn v-if="userIsFleetManager" @click="clearAttachments(task)" small icon text>
                                        <v-icon>close</v-icon>
                                    </v-btn>
                                </v-list-item>                    
                            </div>  
                        </div>
                    </v-list>
                    <span
                        v-if="errors.first('completed tasks') && service.otherTasks.length > 0"
                        class="ml-4 error--text"
                    >select at least one task</span>
                </v-layout>

                <v-layout column class="mx-4">
                    <v-checkbox
                        v-if="!isFutureService"
                        v-model="model.completedOnScheduledDate"
                        class="completed-date-input"
                    >
                        <template
                            v-slot:label
                            v-if="model.completedOnScheduledDate"
                        >Scheduled date ({{ service.date | formatDate }})
                        </template>
                        <template v-slot:prepend>Completed&nbsp;on</template>
                        <template v-slot:append v-if="!model.completedOnScheduledDate">
                            <date
                                v-model="model.completedDate"
                                v-validate="'required'"
                                required
                                name="completed date"
                                :error-messages="errors.first('completed date')"
                                :max="today"
                            ></date>
                        </template>
                    </v-checkbox>
                    <date
                        v-else
                        v-model="model.completedDate"
                        v-validate="'required'"
                        required
                        name="completed date"
                        :error-messages="errors.first('completed date')"
                        :max="today"
                    >
                        <template v-slot:prepend>Completed&nbsp;on</template>
                    </date>
                    <v-text-field
                        v-model="model.completedBy"
                        placeholder="by who? (e.g. 060 - Kris Shepherd)"
                        v-validate="'required'"
                        name="completed by"
                        maxlength="150"
                        :error-messages="errors.first('completed by')"
                        required
                    >
                        <template v-slot:prepend>Completed&nbsp;by</template>
                    </v-text-field>
                    <decimal
                        :precision="2"
                        :pad="false"
                        v-model="model.hoursWorked"
                        placeholder="e.g. 1.5"
                        v-validate="'required|min_value:0|max_value:300'"
                        name="time taken"
                        :error-messages="errors.first('time taken')"
                        required
                        maxlength="6"
                    >
                        <template v-slot:prepend>Time&nbsp;Taken</template>
                        <template v-slot:append>hrs</template>
                    </decimal>
                </v-layout>
                <v-layout column class="mx-4" v-if="userIsFleetManager">
                    <v-checkbox
                        v-model="model.disableMeterValidation"
                        @change="$validator.validate()"
                    >
                        <template v-slot:label>Disable Meter Validation</template>
                    </v-checkbox>
                </v-layout>
                <v-layout column class="mx-4" v-if="attachmentModel.show">
                    <v-checkbox
                        v-model="attachmentModel.allowSubmit"
                        @change="$validator.validate()"
                        :error-messages="errors.first('required-docs')"
                    >
                        <template v-slot:label>Attach documents later</template>
                    </v-checkbox>
                </v-layout>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click="close">Cancel</v-btn>
                    <v-btn
                        color="primary"
                        :disabled="disableSubmit"
                        @click="submit"
                    >{{ service.completed ? 'Update' : 'Complete' }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-wait>
    </v-dialog>
</template>
<script>

  import {Event} from '@/plugins/bus';
  import CONFIG from '@/config';
  import ServicesClient from '@/components/Services/ServicesClient.vue';
  import {VclList} from 'vue-content-loading';
  import moment from 'moment';
  import Decimal from '@/components/Decimal.vue';
  import Date from '@/components/Date.vue';
  import {DateFormat} from '@/plugins/date-filter';
  import {Validator} from 'vee-validate';
  import MetricToleranceCheck from '@/components/MetricToleranceCheck';
  import DocumentInput from '@/components/Services/DocumentInput.vue';

  export default {
    mixins: [ServicesClient, MetricToleranceCheck],
    components: {
      VclList,
      Decimal,
      Date,
      DocumentInput
    },
    data() {
      return {
        service: null,
        show: null,
        model: {
          completedHrsTasks: [],
          completedKmsTasks: [],
          completedOtherTasks: []
        },
        attachments: {
        },
        attachmentModel: {
          allowSubmit: false,
          show: false,
          names: [],
          missing: false
        },
        today: moment().format(DateFormat.Canonical)
      };
    },
    computed: {
      serviceId() {
        return this.$route.query && this.$route.query.serviceId;
      },
      completedDate() {
        return this.model.completedOnScheduledDate ? this.service.date : this.model.completedDate;
      },
      disableSubmit() {
        return Object.keys(this.fields).some(key => this.fields[key].validated && this.fields[key].invalid);
      },
      disableTasks() {
        return this.service.completed && !this.userIsFleetManager;
      },
      isFutureService() {
        return moment(this.service.date).isAfter(this.today);
      },
      completedServiceBeingUpdatedByFleetManager() {
        return this.service.completed && this.userIsFleetManager;
      }
    },
    methods: {
      toggleTask(task, event, completedTasks) {
        if (event.target.classList.value.startsWith('v-input--selection-controls__ripple')) {
          // prevent double toggle when clicking directly on checkbox
          return;
        }
        if (completedTasks.includes(task.id)) {
          completedTasks = completedTasks.filter(id => id !== task.id);
        } else {
          completedTasks.push(task.id);
        }
      },
      submit(event) {
          this.$validator.validate().then(this.doSubmit);
      },
      doSubmit(valid) {
        if (!valid) {
          return;
        }

        if (this.attachmentModel.allowSubmit) {
          this.$confirmCancel.show(
          `Attach Documents Later`,
          `<p>Any documents required are to be uploaded within ${CONFIG.tolerances.documentationOverdueReminderInDays} days</p>`,
          'Continue');

          const continueSubmit = confirmed => {
            this.$confirmCancel.$off('confirm-cancel', continueSubmit);
            if (!confirmed) {
              return;
            }

            this.complete(valid);
          };

          this.$confirmCancel.$on('confirm-cancel', continueSubmit);
        } else {
          this.complete(valid);
        }
      },
      complete(valid) {
        if (!valid) {
          return;
        }

        if (!this.service.completed) {
            this.completeService(this.serviceId, this.model)
              .then(this.submitServiceTaskDocuments(this.serviceId, this.attachments));
          } else {
            this.confirmUpdateCompletedService(this.serviceId, this.model, this.attachments);
          }
      },
      close() {
        this.service = null;
        this.$router.back();
      },
      resetModel() {
        this.model = {
          completedHrsTasks: [],
          completedKmsTasks: [],
          completedOtherTasks: [],
          completedAtHrs: null,
          completedAtKms: null,
          completedBy: null,
          hoursWorked: null,
          completedOnScheduledDate: !this.isFutureService,
          completedDate: this.isFutureService ? moment().format(DateFormat.Canonical) : this.service.date,
          disableMeterValidation: false
        };

        this.attachments = {};
        this.attachmentModel = {
          allowSubmit: false,
          show: false,
          names: [],
          missing: false
        };

        if (this.service.completed) {
          this.model.completedHrsTasks = this.service.hrsTasks.map(t => t.id);
          this.model.completedKmsTasks = this.service.kmsTasks.map(t => t.id);
          this.model.completedOtherTasks = this.service.otherTasks.map(t => t.id);
          this.model.completedBy = this.service.completedBy;
          this.model.hoursWorked = this.service.hoursWorked;
          this.model.completedAtHrs = this.service.completedAtHrs;
          this.model.completedAtKms = this.service.completedAtKms;
          this.model.completedDate = this.service.date;
        }
      },
      selectFiles(files, task) {
        this.attachments[task.id] = files;
      },
      clearAttachments(task) {
        const newAttachments = {...this.attachments};
        newAttachments[task.id] = [];
        this.attachments = newAttachments;
      },
      hasPendingDocuments(task) {
        return this.attachments[task.id] || (task.allowAttachments && task.documents.length === 0);
      }
    },
    watch: {
      async show(val) {
        if (val) {
          this.service = await this.getService(this.serviceId);
          this.resetModel();
        }
      },
      $route: {
        handler(val) {
          this.show = !!this.serviceId;
        },
        deep: true
      }
    },
    async mounted() {
      this.show = !!this.serviceId;
      this.$bus.$on(Event.ServiceCompleted, this.close);

      if (this.show) {
        this.service = await this.getService(this.serviceId);
        this.resetModel();
      }

      const isInRangeHrs = async (value, params) => {
        if (this.model.disableMeterValidation) {
          return true;
        }
        return await this.checkMetricIsInRange(this.service.unitId, 'Hours', value, params[0]);
      };
      const isInRangeKms = async (value, params) => {
        if (this.model.disableMeterValidation) {
          return true;
        }
        return await this.checkMetricIsInRange(this.service.unitId, 'Kilometres', value, params[0]);
      };
      const hasRequiredDocuments = (value, params) => {
        const taskId = params[0];
        const required = params[1] === 'true';
        const selected = this.model.completedHrsTasks.includes(taskId) ||
          this.model.completedKmsTasks.includes(taskId) ||
          this.model.completedOtherTasks.includes(taskId);
        const override = ((required && this.attachmentModel.allowSubmit) || !required || !selected);
        const hasDocuments = (this.attachments[taskId] && this.attachments[taskId].length > 0);

        const result = {
          valid: hasDocuments || override,
          data: {
            required: true
          },
        };

        this.attachmentModel.show = (!hasDocuments && required && selected);
        return result;
      };

      Validator.extend('completed-in-range-hrs', {
        validate: isInRangeHrs,
        getMessage: (field, params, data) => data.message
      });
      Validator.extend('completed-in-range-kms', {
        validate: isInRangeKms,
        getMessage: (field, params, data) => data.message
      });
      Validator.extend(
        'at-least-one',
        _ => {
          return {
            valid: this.model.completedHrsTasks.length + this.model.completedKmsTasks.length + this.model.completedOtherTasks.length > 0,
            data: {
              required: true
            }
          };
        },
        {
          computesRequired: true
        }
      );
      Validator.extend(
        'required-documents', {
          validate: hasRequiredDocuments,
          getMessage: (field, params, data) => `Service documents are required`
        },
        {
          computesRequired: true,
        }
      );
    },
    destroyed() {
      this.$bus.$off(Event.ServiceCompleted, this.close);
    }
  };
</script>
<style>
    .completed-date-input .v-text-field {
        padding-top: 0px;
        margin-top: 0px;
    }
</style>
